var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurepilates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32.3672 19.9805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 19.9805,
    opacity: 0,
    width: 32.3672,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56641 14.5898C3.97266 14.5898 5.12109 13.4531 5.12109 12.0352C5.12109 10.6172 3.97266 9.46875 2.56641 9.46875C1.14844 9.46875 0 10.6172 0 12.0352C0 13.4531 1.14844 14.5898 2.56641 14.5898ZM5.35547 15.4102C4.89844 16.582 5.34375 17.7891 6.31641 18.4688C7.89844 19.5703 9.375 19.9805 11.7305 19.9805L15.4688 19.9805C18.3516 19.9805 19.125 17.7188 18.1406 15.8203L15.1289 10.0078L15.1289 1.21875C15.1289 0.527344 14.5898 0 13.8867 0C13.207 0 12.6914 0.527344 12.6914 1.21875L12.6914 10.3008C12.6914 10.4648 12.7031 10.5938 12.7383 10.7109L14.4375 15.5742L12.2344 15.5742C10.8164 15.5742 9.99609 15.1758 8.88281 14.5078C8.58984 14.332 8.50781 14.0625 8.63672 13.7227L11.3672 6.73828C11.6133 6.11719 11.2969 5.39062 10.6641 5.15625C10.0078 4.91016 9.32812 5.21484 9.08203 5.85938ZM19.7461 18.082L24.082 16.6641L31.0078 15.4102C31.6758 15.293 32.1211 14.6836 32.0039 13.9922C31.875 13.3242 31.2422 12.8906 30.5742 13.0078L23.332 14.3203L19.1484 15.082L19.2422 15.2461C19.8047 16.1836 19.8984 17.2148 19.7461 18.082Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurepilates);
export default __webpack_public_path__ + "static/media/figure.pilates.e384b4b87393db027461210a297b30a5.svg";
export { ForwardRef as ReactComponent };